import { inject, observer } from "mobx-react";

import moment from "moment";

/**
 * Created by jiachenpan on 16/11/18.
 */
// import { bindData as bindDataIn } from './index';
// import { listTree as listTreeIn } from './index';
// import Const from '@const';
// import Cookies from 'js-cookie';


/**
 * 用于递归遍历数组的方法,回调的返回值回map形成一个新的数组
 * @param {Array} arr 需要递归的数组
 * @param {String} chidKey 儿子字段的字段名默认“children”
 * @param {obj} father 儿子的原父级
 * @param {obj} newFather 儿子的新父级（map映射后的）
 * @returns 
 */
export function reduceArr({ arr, cb, chidKey = "children", father = null, newFather = null }) {
    return arr.map(item => {
        const newItem = cb(item, father, newFather);
        const child = item[chidKey];
        if (child && child.length > 0) {
            newItem[chidKey] = reduceArr({ arr: child, cb, father: item, newFather: newItem });
        }
        return newItem;
    });
}


/**
 * 插入千位分隔符
 * @param num
 * @return {*|string}
 */
export function insertThousandsSeparator(num) {
    return (
        num &&
        num.toString().replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
            return $1 + ',';
        })
    );
}

/**
 * 转换fileMark为KB或MB
 * @param f
 */
export function fileMarkChange(f) {
    let size = '';
    if (f <= 500 * 1024) {
        //小于500KB，则转化成KB
        size = (f / 1024).toFixed(2) + 'KB';
    } else {
        // 大于500KB，则转化成MB
        size = (f / (1024 * 1024)).toFixed(2) + 'MB';
    }
    return size;
}

/**
 * 转换秒为hh:mm:ss格式
 * @param s
 * @returns {string}
 */
export function second2HHMMSS(s) {
    let min = parseInt(s / 60, 10);
    const sec = s % 60;
    if (min >= 60) {
        const hour = parseInt(min / 60, 10);
        min = min % 60;
        return `${hour}:${min < 10 ? '0' : ''}${min}:${sec < 10 ? '0' : ''
            }${sec}`;
    }
    return `${min}:${sec < 10 ? '0' : ''}${sec}`;
}

export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null;
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    let date;
    if (typeof time === 'object') {
        date = time;
    } else {
        if (('' + time).length === 10) time = parseInt(time, 10) * 1000;
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    };
    const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === 'a')
            return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
        if (result.length > 0 && value < 10) {
            value = '0' + value;
        }
        return value || 0;
    });
    return timeStr;
}

export function formatTime(time, option) {
    time = +time * 1000;
    const d = new Date(time);
    const now = Date.now();

    const diff = (now - d) / 1000;

    if (diff < 30) {
        return '刚刚';
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前';
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前';
    } else if (diff < 3600 * 24 * 2) {
        return '1天前';
    }
    if (option) {
        return parseTime(time, option);
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        );
    }
}

// 格式化时间
export function getQueryObject(url) {
    url = url === null ? window.location.href : url;
    const search = url.substring(url.lastIndexOf('?') + 1);
    const obj = {};
    const reg = /([^?&=]+)=([^?&=]*)/g;
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1);
        let val = decodeURIComponent($2);
        val = String(val);
        obj[name] = val;
        return rs;
    });
    return obj;
}

/**
 * 格式化对象数组
 * @param objArr 原始数组
 * @param labelKey 标签参数名
 * @param valueKey 值参数名
 * @returns {Array}
 */
export function formatObjArray(objArr, labelKey, valueKey) {
    let arr = [];
    objArr instanceof Array && objArr.forEach(i => arr.push({ label: i[labelKey], value: i[valueKey] }));
    return arr;
}

export function formatRangeTimeOfParams(params, isShort = false) {
    if (params.startTime && params.endTime) {
        params.startTime = parseTime(moment(params.startTime).startOf("day").toDate());
        params.endTime = parseTime(moment(params.endTime).endOf("day").toDate());
        if (isShort) {
            params.startTime = params.startTime.slice(0, 10);
            params.endTime = params.endTime.slice(0, 10);
        }
    }
    return params;
}


export function getUpgradeType() {
    //升级类型
    return [
        {
            value: 1,
            label: 'app升级'
        },
        {
            value: 2,
            label: 'rom全量升级'
        },
        {
            value: 9,
            label: 'rom增量升级'
        },
        {
            value: 3,
            label: '音效升级'
        },
        {
            value: 4,
            label: 'HDMI升级'
        },
        {
            value: 5,
            label: '耳机发射固件升级'
        },
        {
            value: 6,
            label: '耳机接收固件升级'
        },
        {
            value: 7,
            label: '无线耳机MCU程序'
        },
        {
            value: 8,
            label: '无线话筒MCU程序'
        },
    ];
}

/**
 * 获取对应模块在页面中配置的路径
 */
export function getPathOfPage(pageName) {
    const menus = JSON.parse(window.sessionStorage.getItem("menus"));
    // const munusArr = [];
    let returnPath;
    menus.some(i => {
        const headPath = i.routePath;
        if (pageName === i.component) {
            returnPath = `/${headPath}`;
            return true;
        }
        if (i.children) {
            const isHas = i.children.some(j => {
                if (j.type !== 2) return;
                const endPath = j.routePath;
                const component = j.component;
                // const name = j.name;
                const path = `/${headPath}/${endPath}`;
                // munusArr.push({ path, component, name });
                if (pageName === component) {
                    returnPath = path;
                    return true;
                }
            });
            return isHas;
        }
        // if (i.type === 2) munusArr.push({ path: `/${headPath}/${endPath}`, name: i.name, component: i.component });
    });
    return returnPath;
}

/**
 * 获取含有children的list中某个key为value值的，其中父亲不满足，儿子满足，应该返回父亲以及期满足条件的儿子
 */
export function filterListWithChildren(list, key, value) {
    if (value === undefined) return list;
    return list.filter(itemFather => {
        let flagFather, flagChild;
        if (itemFather.children && itemFather.children.length > 0) {
            const children = itemFather.children.filter(itemSon => {
                if (itemSon[key] === value) {
                    flagChild = true;
                    return true;
                }
                return false;
            });
            itemFather.children = children;
        }
        if (itemFather[key] === value) {
            flagFather = true;
        }
        return flagFather || flagChild;
    });
}

/**
 * 路径拼接
 */
export function joinUrl(...path) {
    if (!path) return "";
    return path.map(p => `${p}`.replace(/(^\/|\/$)/g, "")).join("/");
}

